import { render, staticRenderFns } from "./AssignEntityReationshipDataWidget.vue?vue&type=template&id=94587ade&scoped=true"
import script from "./AssignEntityReationshipDataWidget.vue?vue&type=script&lang=js"
export * from "./AssignEntityReationshipDataWidget.vue?vue&type=script&lang=js"
import style0 from "./AssignEntityReationshipDataWidget.vue?vue&type=style&index=0&id=94587ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94587ade",
  null
  
)

export default component.exports